function toCustomPropertyName(key) {
  return `--ifl-${key.replace("-[base]", "")}`;
}
function toCustomPropertyValue(key) {
  return `var(${toCustomPropertyName(key)})`;
}
function createColorProperties(obj, objParentName) {
  let properties = {};
  Object.keys(obj).forEach(key => {
    const value = obj[key];
    const name = `${objParentName}-${key}`;
    if (value && typeof value === "object") {
      properties = {
        ...properties,
        ...createColorProperties(value, name)
      };
    } else {
      properties[toCustomPropertyName(name)] = value;
    }
  });
  return properties;
}
function createCustomPropertyTheme(theme) {
  const {
    colors,
    shadows,
    ...remainingTheme
  } = theme;
  const rawColorsWithoutColorModes = {
    ...colors
  } || {};
  const colorsAsCustomProperties = rawValuesToCustomProperties(rawColorsWithoutColorModes, "colors");
  const shadowsAsCustomProperties = rawValuesToCustomProperties(shadows || {}, "shadows");
  const lightShadows = {
    ...shadows
  };
  if ("EXPERIMENTAL_colorModes" in lightShadows) {
    delete lightShadows.EXPERIMENTAL_colorModes;
  }
  // eslint-disable-next-line camelcase
  shadowsAsCustomProperties.EXPERIMENTAL_colorModes = {
    ...shadowsAsCustomProperties.EXPERIMENTAL_colorModes,
    light: lightShadows
  };
  if ("EXPERIMENTAL_colorModes" in rawColorsWithoutColorModes) {
    delete rawColorsWithoutColorModes.EXPERIMENTAL_colorModes;
  }
  const rawColors = {
    ...rawColorsWithoutColorModes,
    // eslint-disable-next-line camelcase
    EXPERIMENTAL_light: rawColorsWithoutColorModes,
    // eslint-disable-next-line camelcase
    EXPERIMENTAL_dark: colors?.EXPERIMENTAL_colorModes?.dark || {}
  };
  return {
    ...remainingTheme,
    colors: colorsAsCustomProperties,
    rawColors,
    shadows: shadowsAsCustomProperties
  };
}
function rawValuesToCustomProperties(obj, objParentName) {
  const references = {};
  Object.keys(obj).forEach(key => {
    const value = obj[key];
    const name = `${objParentName}-${key}`;
    if (value && typeof value === "object") {
      if (key === "EXPERIMENTAL_colorModes") {
        references[key] = value;
      } else {
        references[key] = rawValuesToCustomProperties(value, name);
      }
    } else {
      references[key] = toCustomPropertyValue(name);
    }
  });
  return references;
}
function isIndeedTheme(theme) {
  return theme._themeName === "indeed";
}

export { createColorProperties, createCustomPropertyTheme, isIndeedTheme };
